import { FC } from 'react';
import * as S from './styles';
import _Play from './icons/play.svg';

type PlayButtonProps = {
  onClick: () => void;
};

const PlayButton: FC<PlayButtonProps> = props => {
  return (
    <S.PlayButton {...props}>
      <S.Play Svg={_Play} />
    </S.PlayButton>
  );
};

export default PlayButton;
